import { useQuery } from '@tanstack/react-query'

import { useSession } from '@/contexts/SessionContext'
import { rows } from '@/db/database'
import { DiscountCap } from '@/services/PricingService'

/** The acting cashier's `max_discount` (§7.2) from their staff record on the device; null when none is set. */
export const useDiscountCap = () => {
  const { cashier, stage } = useSession()
  const { data = null } = useQuery({
    queryKey: ['discount-cap', cashier?._id],
    queryFn: async (): Promise<DiscountCap | null> => {
      const staff = await rows('users').where('_id').equals(cashier!._id).first()
      const value = Number(staff?.max_discount ?? 0)
      return value > 0 ? { value, type: staff?.max_discount_type === 'percentage' ? 'percentage' : 'cash' } : null
    },
    enabled: stage !== 'demo' && !!cashier,
  })
  return data
}
